import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=08b95cb8&scoped=true&"
import script from "./Invoice.vue?vue&type=script&lang=ts&"
export * from "./Invoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b95cb8",
  null
  
)

export default component.exports